import { render, staticRenderFns } from "./mainEnter.vue?vue&type=template&id=1308126b&scoped=true&"
import script from "./mainEnter.vue?vue&type=script&lang=js&"
export * from "./mainEnter.vue?vue&type=script&lang=js&"
import style0 from "./mainEnter.vue?vue&type=style&index=0&id=1308126b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1308126b",
  null
  
)

export default component.exports